import dayjs from 'dayjs'

import 'dayjs/locale/en'
import 'dayjs/locale/hu'
import timezone from 'dayjs/plugin/timezone'
import localeData from 'dayjs/plugin/localeData'
import updateLocale from 'dayjs/plugin/updateLocale'

dayjs.extend(timezone)
dayjs.extend(localeData)
dayjs.extend(updateLocale)

dayjs.locale('hu')

dayjs.tz.setDefault('Europe/Budapest')

export default (context, inject) => {
  context.$dayjs = dayjs
  inject('dayjs', dayjs)
}
